export function therapistIsVerified(user) {
    if (!user?.isTherapist) return true;
    if (user?.googleTokens && user?.eventsUrl && user?.calendarId) return true;
    return false;
}